// extracted by mini-css-extract-plugin
export default {"zoomModal":"w3-z"};